import { createContext, useContext, useState, useCallback } from 'react';

const PursuitContext = createContext(null);

// Mock pursuits for demo
export const MOCK_PURSUITS = [
  { 
    id: 'pursuit-001', 
    rfpNumber: 'NASA-SEWP-VI', 
    title: 'NASA SEWP VI IT Services', 
    client: 'Acme Defense Systems',
    clientId: 'acme-corp',
    status: 'Pursuing',
    dueDate: '2026-03-15',
    pWinScore: 72
  },
  { 
    id: 'pursuit-002', 
    rfpNumber: 'DOD-JEDI-2026', 
    title: 'DoD Cloud Infrastructure', 
    client: 'Stellar Technologies Inc',
    clientId: 'stellar-tech',
    status: 'Qualifying',
    dueDate: '2026-04-01',
    pWinScore: 45
  },
  { 
    id: 'pursuit-003', 
    rfpNumber: 'VA-EHR-MOD', 
    title: 'VA EHR Modernization Support', 
    client: 'Nova Solutions Group',
    clientId: 'nova-solutions',
    status: 'Identified',
    dueDate: '2026-05-20',
    pWinScore: null
  },
];

export function PursuitProvider({ children }) {
  const [activePursuit, setActivePursuit] = useState(null);
  const [pursuitHistory, setPursuitHistory] = useState([]);

  const enterPursuit = useCallback((pursuit) => {
    setActivePursuit(pursuit);
    setPursuitHistory(prev => {
      // Add to history if not already there
      if (!prev.find(p => p.id === pursuit.id)) {
        return [pursuit, ...prev].slice(0, 5); // Keep last 5
      }
      return prev;
    });
  }, []);

  const exitPursuit = useCallback(() => {
    setActivePursuit(null);
  }, []);

  // Clear all pursuit state (called on logout)
  const clearPursuitState = useCallback(() => {
    setActivePursuit(null);
    setPursuitHistory([]);
  }, []);

  const value = {
    activePursuit,
    pursuitHistory,
    enterPursuit,
    exitPursuit,
    clearPursuitState,
    isInPursuitContext: !!activePursuit,
  };

  return (
    <PursuitContext.Provider value={value}>
      {children}
    </PursuitContext.Provider>
  );
}

export function usePursuit() {
  const context = useContext(PursuitContext);
  if (!context) {
    throw new Error('usePursuit must be used within a PursuitProvider');
  }
  return context;
}

export default PursuitContext;
